import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { HomeMetric } from "../../../models/home";
import { LanguageService } from "../../../services/language/language.service";
import { UxError } from "../../../models/ux-error.model";

@Component({
  selector: "app-home-stats",
  templateUrl: "./home-stats.component.html",
  styleUrls: ["./home-stats.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HomeStatsComponent {
  @Input() metrics: readonly HomeMetric[] | null = null;
  @Input() loading = false;
  @Input() error: UxError | null = null;
  @Input() empty = false;
  @Output() retryRequest = new EventEmitter<void>();

  constructor(public lang: LanguageService) {}

  getMetricLabel(metric: HomeMetric): string {
    const key = (metric.label ?? "").toLowerCase();
    const known = HomeStatsComponent.labelMap[key];
    if (known) {
      return this.lang.translate(known);
    }
    return metric.label;
  }

  onRetry(): void {
    this.retryRequest.emit();
  }

  private static readonly labelMap: Record<string, string> = {
    "pending_documents": "home.stats.label.pending_documents",
    "evaluated_documents": "home.stats.label.evaluated_documents",
    "oldest_pending_age_seconds": "home.stats.label.oldest_pending_age_seconds",
    "last_evaluation_age_seconds": "home.stats.label.last_evaluation_age_seconds",
    "evaluation_duration_p95_ms": "home.stats.label.evaluation_duration_p95_ms",
    "evaluation_duration_p99_ms": "home.stats.label.evaluation_duration_p99_ms",
    "ranker_duration_p95_ms": "home.stats.label.ranker_duration_p95_ms",
    "ranker_duration_p99_ms": "home.stats.label.ranker_duration_p99_ms",
    "error_rate": "home.stats.label.error_rate",
    "throughput_eval_per_hour": "home.stats.label.throughput_eval_per_hour",
    "throughput_rank_per_hour": "home.stats.label.throughput_rank_per_hour"
  };
}
